import { Method } from "@inertiajs/inertia";
import { Link } from "@inertiajs/inertia-react";
import usePageProps from "app/components/hooks/usePageProps";
import Icon from "app/components/Icon";
import Img from "app/components/Image";
import { MODALS, ModalsContext } from "app/components/Layouts/Modals";
import { TaskType } from "app/components/Types/TaskType";
import { TrackingType } from "app/components/Types/TrackingType";
import { UserType } from "app/components/Types/UserType";
import moment, { duration } from "moment";
import { useState } from "react";
import { createContext } from "react";
import { useContext } from "react";
import route from "ziggy-js";
import IconText from "./IconText";
import { UserAvatar } from "./UserAvatar";

export const EditMenuContext = createContext<{ opened: { id: number, type: string } | null, setOpened: any }>({ opened: null, setOpened: (res) => { } });

export function EditMenuContextProvider(props) {

    const [opened, setOpened] = useState<{ id: number, type: string } | null>(null)



    return (
        <EditMenuContext.Provider value={{ opened: opened, setOpened: setOpened }} >
            <div onClick={() => setOpened(null)}>
                {props.children}
            </div>
        </EditMenuContext.Provider>
    )
}

export function TaskCard({ t }: { t: TaskType; }) {
    let { open, modal } = useContext(ModalsContext);

    const z = (num) => num;

    let estimate = duration(t.estimate);
    let total = duration(t.total);
    let u_estimate = duration(t.upper_estimate);

    const { opened, setOpened } = useContext(EditMenuContext);

    const { user, task, current_tracking, current_task } = usePageProps<{ user: UserType, task?: TaskType, current_tracking?: TrackingType, current_task: TaskType }>();


    return (
        <Link href={route('tasks.show', { task: t.id })} className="p-18px pt-12px bg-gray-1C1C1C rounded flex flex-col justify-between">
            <div className="flex justify-between items-center">
                <div className="text-18 font-semibold">{t.name}</div>
                <div className="flex gap-2px items-center">
                    <div className="flex-shrink-0">
                        {(current_tracking && current_task.id == t.id) && <Link as="button" href={route('trackings.end')} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='bg-red/40 hover:bg-red rounded-full h-40px w-40px flex items-center justify-center font-bold text-18 text-white'>
                            <Icon name="pause" />
                        </Link>}
                        {(!current_tracking) && <Link as="button" href={route('trackings.start', { task: t.id })} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='hover:bg-white/5 rounded-full h-40px w-40px flex items-center justify-center text-white'>
                            <Icon name="play" />
                        </Link>}
                    </div>

                    <div className={`flex items-center gap-x-8px relative p-8px ${(opened?.id == t.id && opened.type == 'task') ? 'bg-gray-343434 rounded-t-full withInverse' : 'hover:bg-white/5 rounded-full'}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpened((opened?.id == t.id && opened.type == 'task') ? null : { id: t.id, type: 'task' }) }}>
                        <Icon className={"text-white"} name="more" />
                        {
                            (opened?.id == t.id && opened.type == 'task') &&
                            <div className="absolute flex flex-col justify-start items-end right-0 bottom-1px translate-y-full" onClick={e => e.stopPropagation()}>
                                <div className="bg-gray-343434 rounded-md rounded-tr-none  flex flex-col gap-2px font-semibold z-10 overflow-hidden">
                                    <IconText className="hover:bg-white/5 px-20px py-15px " onClick={e => { e.preventDefault(); e.stopPropagation(); open(MODALS.EDITTASK, false, { task: t }); }} icon="pen" text="Edit" />
                                    <Link onClick={e => e.stopPropagation()} href={route('tasks.destroy', { task: t.id })} method={Method.POST} as="button" preserveState={false}><IconText className="text-red-FF0539 hover:bg-white/5 px-20px py-15px " icon="bin" text="Delete" /></Link>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="flex justify-between mt-10px">
                <div className="bg-gray-343434 p-8px text-white font-medium rounded-full text-12">{t.project.name}</div>
                <div className="flex">
                    {
                        t?.users?.slice(0, 3).map(u =>
                            <UserAvatar user={u} />
                        )
                    }
                    {
                        (t?.users?.length > 3) &&
                        <div className="rounded-full h-32px w-32px border-2 border-gray-1C1C1C bg-gray-343434 -mx-4px flex items-center justify-center overflow-hidden"
                            title={t?.users?.slice(3).reduce((p, c, i) => `${p}${i > 0 ? ', ' : ''}${c.name}`, '')}
                        >
                            +{t.users.length - 3}
                        </div>
                    }
                </div>
            </div>
            <div className="mt-20px">
                <div className="flex justify-between">
                    <div className="flex gap-8px items-center">
                        <Icon name="target" />
                        <div className="text-14">{moment(t.deadline, 'D. M. YYYY H:i').format('D. M. YYYY')}</div>
                    </div>
                    <div className="flex gap-8px items-center">
                        <div className="text-14">{`${z(Math.floor(total.asHours()))}h ${z(total.minutes())}m`} <span className=" text-white/50">/ {`${z(Math.floor(u_estimate.asHours()))}h ${z(u_estimate.minutes())}m`}</span></div>
                    </div>
                </div>
                <div className="bg-gray-343434 h-2px w-full rounded-full overflow-hidden mt-12px">
                    <div className="bg-green-539648 h-full" style={{ width: `${Math.min(t.progress, 100)}%` }} />
                </div>
            </div>
        </Link>
    );
}

export function TaskRow({ t }: { t: TaskType; }) {
    let { open, modal } = useContext(ModalsContext);

    const z = (num) => num;

    let estimate = duration(t.estimate);
    let total = duration(t.total);
    let u_estimate = duration(t.upper_estimate);

    const { opened, setOpened } = useContext(EditMenuContext);

    const { user, task, current_tracking, current_task } = usePageProps<{ user: UserType, task?: TaskType, current_tracking?: TrackingType, current_task: TaskType }>();


    return (
        <Link href={route('tasks.show', { task: t.id })} className="p-18px pt-12px bg-gray-1C1C1C rounded flex flex-col justify-between">
            <div className="flex justify-between">
                <div className="flex justify-between items-center gap-16px">
                    <div className="text-18 font-semibold">{t.name}</div>
                    <div className="bg-gray-343434 p-8px text-white font-medium rounded-full text-12">{t.project.name}</div>
                </div>
                <div className="flex justify-between mt-10px">
                   
                    <div className="flex gap-16px items-center">
                        <div className="flex">
                            {
                                t?.users?.slice(0, 3).map(u =>
                                    <UserAvatar user={u} />
                                )
                            }
                            {
                                (t?.users?.length > 3) &&
                                <div className="rounded-full h-32px w-32px border-2 border-gray-1C1C1C bg-gray-343434 -mx-4px flex items-center justify-center overflow-hidden"
                                    title={t?.users?.slice(3).reduce((p, c, i) => `${p}${i > 0 ? ', ' : ''}${c.name}`, '')}
                                >
                                    +{t.users.length - 3}
                                </div>
                            }
                        </div>
                        <div className={`flex items-center gap-x-8px relative p-8px ${(opened?.id == t.id && opened.type == 'task') ? 'bg-gray-343434 rounded-t-full withInverse' : 'hover:bg-white/5 rounded-full'}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpened((opened?.id == t.id && opened.type == 'task') ? null : { id: t.id, type: 'task' }) }}>
                            <Icon className={"text-white"} name="more" />
                            {
                                (opened?.id == t.id && opened.type == 'task') &&
                                <div className="absolute flex flex-col justify-start items-end right-0 bottom-1px translate-y-full" onClick={e => e.stopPropagation()}>
                                    <div className="bg-gray-343434 rounded-md rounded-tr-none  flex flex-col gap-2px font-semibold z-10 overflow-hidden">
                                        <IconText className="hover:bg-white/5 px-20px py-15px " onClick={e => { e.preventDefault(); e.stopPropagation(); open(MODALS.EDITTASK, false, { task: t }); }} icon="pen" text="Edit" />
                                        <Link onClick={e => e.stopPropagation()} href={route('tasks.destroy', { task: t.id })} method={Method.POST} as="button" preserveState={false}><IconText className="text-red-FF0539 hover:bg-white/5 px-20px py-15px " icon="bin" text="Delete" /></Link>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-20px">
                <div className="flex justify-between">
                    <div className="flex gap-8px items-center">
                        <Icon name="target" />
                        <div className="text-14">{moment(t.deadline, 'D. M. YYYY H:i').format('D. M. YYYY')}</div>
                    </div>
                    <div className="flex gap-8px items-center">
                        <div className="flex-shrink-0">
                            {(current_tracking && current_task.id == t.id) && <Link as="button" href={route('trackings.end')} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='bg-red/40 hover:bg-red rounded-full h-40px w-40px flex items-center justify-center font-bold text-18 text-white'>
                                <Icon name="pause" />
                            </Link>}
                            {(!current_tracking) && <Link as="button" href={route('trackings.start', { task: t.id })} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='hover:bg-white/5 rounded-full h-40px w-40px flex items-center justify-center text-white'>
                                <Icon name="play" />
                            </Link>}
                        </div>
                        <div className="text-14">{`${z(Math.floor(total.asHours()))}h ${z(total.minutes())}m`} <span className=" text-white/50">/ {`${z(Math.floor(u_estimate.asHours()))}h ${z(u_estimate.minutes())}m`}</span></div>
                    </div>
                </div>
                <div className="bg-gray-343434 h-2px w-full rounded-full overflow-hidden mt-12px">
                    <div className="bg-green-539648 h-full" style={{ width: `${Math.min(t.progress, 100)}%` }} />
                </div>
            </div>
        </Link>
    );
}
